import Footer from 'components/Generics/Footer/Footer';
import Header from 'components/Generics/Header/ApricotHeader';
import React from 'react';
import * as S from 'components/Logout/ApricotLogout.style';
import { Trans, useTranslation } from 'react-i18next';

const ApricotLogout = (): React.ReactElement => {

    const { t } = useTranslation();
    const apricotLogoutMSG = t('public:APRICOT_LOGOUT_MSG');
    return (
        <S.ApricotBackground>
            <Header />
            <S.Content>
                <S.ApricotLogoutMsg>
                    <Trans>{apricotLogoutMSG}</Trans>
                </S.ApricotLogoutMsg>
            </S.Content>
            <Footer />
        </S.ApricotBackground>
    );
};

export default ApricotLogout;